import React from "react";

import { moneyFormat } from "./format";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import Formula from "./Formula";
import { IncomeStatementPanel } from "./IncomeStatement";

const ImpactOfDebt = ({ incomeStatement }) => {
  const interestExpense = incomeStatement["Interest Expense"];

  return (
    <TwoPanels
      title1="Financial Impact of Holding Debt"
      title2="IncomeStatement"
    >
      <fragment>
        {interestExpense !== 0 ? (
          <Text>
            <b>Interest Expense</b>: Your Interest Expense of{" "}
            {moneyFormat(interestExpense)} was driven by the weighted average
            interest rate your lenders charged you given the amount of money you
            borrowed.
          </Text>
        ) : null}
        <Formula>Interest Expense = Money Borrowed x Interest Rates</Formula>
        <Text>
          In this game, lenders determine your interest rates based on your debt
          to capital ratio. For more details, please review the MG Business
          Case.
        </Text>
      </fragment>
      <IncomeStatementPanel sheet={incomeStatement} />
    </TwoPanels>
  );
};

export default ImpactOfDebt;



// WEBPACK FOOTER //
// ./src/components/analysis/ImpactOfDebt.js